import { Component, Inject, OnDestroy, OnInit } from '@angular/core';
import { UploadCoverService } from '../../providers/Table/uploadCover.service';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-choicewinmedia',
  templateUrl: './choiceWinmedia.component.html',
  styleUrls: ['./choiceWinmedia.component.scss']
})
export class ChoiceWinmediaComponent implements OnInit, OnDestroy {

  constructor(private uploadCoverService: UploadCoverService,
              @Inject(MAT_DIALOG_DATA) public dataIn,
              private dialogRef: MatDialogRef<any>) {}

  ngOnInit() {
    console.log(this.dataIn);
  }

  ngOnDestroy() {}

  closeDialog(newUpload: boolean): void {
    this.dialogRef.close({userAction: true, newUpload: newUpload});
  }

}
